<template>
    <div class="navy-dark" style="width:100%">
        <div id="newsletterContainer" class="container container--900 p-30">

            <slot name="title"></slot>
            <slot name="description"></slot>

            <form @submit="onSubmit" class="form">
                <div v-if="!subscribed">
                    <div class="row">
                        <div class="col-9-sm mb-10">
                            <div class="form__field form__field mb-0">
                                <div class="form__input">
                                    <input v-model="email" name="email" type="email" placeholder="Enter your email" required>
                                </div>
                            </div>
                        </div>
                        <div class="mb-10 col-3-sm col-12" style="align-self: center" :class="{'col-4-sm' : !ctaInline}">
                            <button class="button button--full button--orange" type="submit">Sign up</button>
                        </div>
                    </div>
                    <p v-if="v$.email.$error" class="text-red" style="margin-left: 5px;">{{ this.validationMsg }}</p>
                </div>
                <div v-if="subscribed" class="mpanel mpanel--padding mpanel--rounded text-navy-dark">
                    {{ this.successMsg }}
                </div>
                <div v-if="hasError" class="mpanel mpanel--padding mpanel--rounded text-navy-dark">
                    {{ this.errorMsg }}
                </div>
            </form>

            <slot name="footer"></slot>

        </div>
    </div>
</template>

<script>
import {useVuelidate} from '@vuelidate/core';
import {required, email} from '@vuelidate/validators';
import axiosClient from '../modules/axiosClient';

export default {
    name: 'newsletter',
    props: {
        'backgroundImageUrl': {type: String, default: ''},
        'ctaInline': {type: Boolean, default: true},
        'source': {type: Number, default: ''},
        'successMsg': {type: String, default: 'Thank you  for subscribing to our newsletter'},
        'errorMsg': {type: String, default: 'Oops there has been a problem, please try again'},
    },
    setup() {
        return {v$: useVuelidate()};
    },
    data() {
        return {
            'csrfToken': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            'email': '',
            'validationMsg': '',
            'subscribed': false,
            'hasError': false,
            'apiUrl': '/newsletter-subscribe',
        };
    },
    mounted() {
        if (this.hasBackgroundImageUrl) {
            const container = document.getElementById('newsletterContainer');
            container.style.backgroundImage = 'url(' + this.backgroundImageUrl + ')';
            container.style.backgroundSize = 'cover';
        }
    },
    validations() {
        return {
            email: {required, email},
        };
    },
    computed: {
        hasBackgroundImageUrl() {
            return this.backgroundImageUrl !== '';
        },
        ctaInline() {
            return this.ctaInline;
        },
    },
    methods: {
        onSubmit(event) {
            event.preventDefault();

            const headers = {
                'X-CSRF-TOKEN': this.csrfToken,
            };

            const parameters = {
                email: this.email,
                source: this.source,
            };

            axiosClient.post(this.apiUrl, parameters, headers).then((response) => {
                if (response.status !== 200) {
                    this.hasError = true;
                }
                if (response.data.success) {
                    this.subscribed = true;
                }
            });
        },
    },
    watch: {
        email() {
            this.v$.$validate();

            if (this.v$.email.$error && this.email.length !== 0) {
                return this.validationMsg = 'Please enter a valid email';
            }

            return this.validationMsg = '';
        },
    },
};
</script>
